import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import {} from 'services/api/types'

const toastId = 'loadCustomerInfo'

type LoadCustomerInfoInput = {
  customerId?: string
}

const loadCustomerInfo = (input: LoadCustomerInfoInput): any => {
  return axios.get(`/customers/${input.customerId}`)
}

export function useLoadCustomerInfo(params: LoadCustomerInfoInput) {
  return useQuery(
    ['loadCustomerInfo', params],
    () => loadCustomerInfo(params),
    {
      enabled: !!params?.customerId,
      onError: () =>
        toast.error('Não foi possível carregar as informações do cliente', {
          toastId
        })
    }
  )
}
